import { useToast } from "@chakra-ui/react";
import React, { useContext, useState } from "react";
import FormContext from "../context/formContext";
import Loader from "./loader";

function SignUp() {
  const toast = useToast();
  const [userRegister, setUserRegister] = useState({});
  const [agreement, setAgreement] = useState(false);
  const context = useContext(FormContext);
  const { setShowform } = context;
  const [showEye, setShowEye] = useState(false);
  const [passwordType, setPasswordType] = useState("password");
  const [signUploader, setSignUploader] = useState(false);
  

  const handlePasswordShow = () => {
    if (showEye === true) {
      setShowEye(false);
      setPasswordType("password");
    } else {
      setShowEye(true);
      setPasswordType("text");
    }
  };

  const handleChange = (e) => {
    setAgreement(e.target.checked);
  };

  const handleSignUpSubmit = (e) => {
    e.preventDefault();

    setSignUploader(true);
    setAgreement(false);

    // userRegister["Branch_id"] = "1729";
    userRegister["Branch_id"] = "2244";
    userRegister["db_name"] = "erp_eshiksa";
    // console.log(userRegister)
    if (userRegister.cnfPassword !== userRegister.password) {
      toast({
        title: "Alert",
        description: "Password and Confirm Password does not match",
        status: "error",
        duration: 1000,
        isClosable: true,
        position: "top",
      });
    } else {
      if (userRegister.mobile_no) {
        if (userRegister.mobile_no.length !== 10) {
          toast({
            title: "Alert",
            description: "Please provide correct Contact Number",
            status: "error",
            duration: 1000,
            isClosable: true,
            position: "top",
          });
        } else {
          var myHeaders = new Headers();
          myHeaders.append("Content-Type", "application/json");
          // myHeaders.append("Cookie", "ci_session=h5p14qe73e4tmhbobcle4shvrf0a6olp");

          var raw = JSON.stringify(userRegister);
          var request = {
            "request":btoa(raw)
          }
          var final_request = JSON.stringify(request);
          var requestOptions = {
            method: "POST",
            headers: myHeaders,
            body: final_request,
            redirect: "follow",
          };

          fetch("https://erpapi.eshiksa.net/Gadvasu/Signup.php", requestOptions)
            .then((response) => response.text())
            .then((result) => {
              var jsonObj = JSON.parse(result);

              if (jsonObj.success === 0) {

                // if(jsonObj.error.mobile_no){
                // var mobileErrmessage = jsonObj.error.mobile_no;
                // console.log(mobileErrmessage)
                // setMobileErr(mobileErrmessage);
                // }

                setSignUploader(false);
                setAgreement(true);

                if (jsonObj.msg) {
                  toast({
                    title: "Alert",
                    description: jsonObj.msg,
                    status: "error",
                    duration: 1000,
                    isClosable: true,
                    position: "top",
                  });
                }
              }
              if (jsonObj.success === 1) {
                setShowform(false);
                setSignUploader(false);
                toast({
                  title: "Alert",
                  description: jsonObj.msg,
                  status: "success",
                  duration: 1000,
                  isClosable: true,
                  position: "top-right",
                });
              }
            })
            .catch((error) => console.log("error", error));
        }
      }
    }

    // setTimeout(() => {
    //   setUserRegister({});
    // }, "2000");

    // console.log(userRegister);
  };

  const handleContactl = (e) => {
    let input = e.target.value;
    e.target.value = input.slice(0, 10);
  };

  return (
    <div>
      <form onSubmit={(e) => handleSignUpSubmit(e)}>
        <div className="d-flex flex-wrap w-75 mx-auto flex-column pt-3">
          <label className="form-label"> User Name/Applicant's Name </label>
          <input
            className="form-control"
            autoComplete="off"
            value={userRegister.name}
            onChange={(e) =>
              setUserRegister({
                ...userRegister,
                [e.target.name]: e.target.value,
              })
            }
            name="name"
            type="text"
            required
          />
        </div>
        <div className="d-flex flex-wrap w-75 mx-auto flex-column my-1">
          <label className="form-label"> Contact Number </label>
          <input
            className="form-control number-input"
            autoComplete="off"
            value={userRegister.mobile_no}
            onKeyUp={(e) => handleContactl(e)}
            onChange={(e) => {
              setUserRegister({
                ...userRegister,
                [e.target.name]: e.target.value,
              });
            }}
            name="mobile_no"
            type="number"
            required
          />
          {/* <p className="subtext">{mobileErr}</p> */}
        </div>
        <div className="d-flex flex-wrap w-75 mx-auto flex-column my-1">
          <label className="form-label"> User Email </label>
          <input
            className="form-control"
            autoComplete="off"
            value={userRegister.email}
            onChange={(e) =>
              setUserRegister({
                ...userRegister,
                [e.target.name]: e.target.value,
              })
            }
            name="email"
            type="email"
            required
          />
        </div>
        <div className="d-flex flex-wrap w-75 mx-auto flex-column my-1">
          <label className="form-label"> Password </label>
          <input
            className="form-control"
            autoComplete="off"
            value={userRegister.password}
            onChange={(e) =>
              setUserRegister({
                ...userRegister,
                [e.target.name]: e.target.value,
              })
            }
            name="password"
            type="password"
            required
          />
        </div>
        <div className="d-flex flex-wrap w-75 mx-auto flex-column my-1">
          <label className="form-label">Confirm Password </label>
          <div className="input-group">
            <input
              className="form-control"
              autoComplete="off"
              style={{
                border: "none",
                borderRadius: "0.25rem 0px 0px 0.25rem",
              }}
              // value={userRegister.password}
              onChange={(e) =>
                setUserRegister({
                  ...userRegister,
                  [e.target.name]: e.target.value,
                })
              }
              name="cnfPassword"
              type={passwordType}
              required
            />
            <div className="input-group-prepend">
              <button
                className="btn bg-white form-control"
                type="button"
                style={{
                  border: "none",
                  borderRadius: "0px 0.25rem 0.25rem 0px",
                }}
                onClick={handlePasswordShow}
              >
                {showEye === true ? (
                  <i className="fa-regular fa-eye-slash"></i>
                ) : (
                  <i className="fa-regular fa-eye"></i>
                )}
              </button>
            </div>
          </div>
        </div>
        <div className="d-flex flex-wrap w-75 mx-auto flex-row my-2">
          <input
            className="float-start"
            type="checkbox"
            onChange={handleChange}
          />
          <label className="form-check-label">
            I agree to receive information regarding my submitted application by
            signing up*
          </label>
        </div>
        <div className="d-flex flex-wrap w-75 mx-auto my-3 justify-content-around">
          <button
            type="submit"
            className="btn btn-sm btn-primary w-50"
            disabled={!agreement}
          >
            Submit
            {
              signUploader && <Loader/>
            }
            
          </button>
        </div>
      </form>
    </div>
  );
}

export default SignUp;
